// Author thq
// Date 2024-03-29 10:09:52

class EmMaMaintenanceWo {
    constructor({
                    id = null,
                    ids = '',
                    emArchBasicDataCode = '',
                    emMaMaintenanceCatId = '',
                    emMaMaintenanceScheduleId = '',
                    repairPlanId = '',
                    mmwoAuthor = '',
                    mmwoExecutor = '',
                    mmwoAcceptor = '',
                    emArchToolKitId = '',
                    planStartDate = '',
                    planEndDate = '',
                    jobContent = '',
                    safeContent = '',
                    attachment = ''
                }
                    = {}) {
        this.id = id;
        this.ids = ids;
        this.emArchBasicDataCode = emArchBasicDataCode;
        this.emMaMaintenanceCatId = emMaMaintenanceCatId;
        this.emMaMaintenanceScheduleId = emMaMaintenanceScheduleId;
        this.repairPlanId = repairPlanId;
        this.mmwoAuthor = mmwoAuthor;
        this.mmwoExecutor = mmwoExecutor;
        this.mmwoAcceptor = mmwoAcceptor;
        this.emArchToolKitId = emArchToolKitId;
        this.planStartDate = planStartDate;
        this.planEndDate = planEndDate;
        this.jobContent = jobContent;
        this.safeContent = safeContent;
        this.attachment = attachment;
    }
}

function newEntity() {
    return new EmMaMaintenanceWo();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'statusName',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.statusName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workOrderCode',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.workOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'emArchBasicDataCode',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.emArchBasicDataCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'emArchBasicDataName',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.emArchBasicDataName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'emMaMaintenanceCatName',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.emMaMaintenanceCatName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'emMaMaintenanceScheduleId',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.emMaMaintenanceScheduleId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'emMaMaintenanceScheduleName',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.emMaMaintenanceScheduleName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmwoAuthorName',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.mmwoAuthorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmwoExecutorName',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.mmwoExecutorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmwoAcceptorName',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.mmwoAcceptorName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'jobContent',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.jobContent',
            sortable: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'safeContent',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.safeContent',
            sortable: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'planStartDate',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.planStartDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'planEndDate',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.planEndDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string',
                customClass: (row) => {
                    //超过一天的变红
                    if (row.planEndDate !== undefined && row.planEndDate !== '') {
                        //把字符串格式转化为日期类
                        let planFinishTime = new Date(Date.parse(row.planEndDate))
                        //如果定修工单状态不是‘完成’，跟现在时间对比，超一天变红
                        //如果定修工单状态是‘完成’，跟实际完成时间或者工作流完成时间对比
                        if (row.statusName !== '完成') {
                            let warnTime = new Date()
                            warnTime.setDate(warnTime.getDate() - 1);
                            if (planFinishTime < warnTime) {
                                return "bg-danger text-dark"
                            } else {
                                return "";
                            }
                        }
                        // else {
                        //     let finishDate = new Date();
                        //     if (row.actualFinishDate) {
                        //         finishDate = new Date(Date.parse(row.actualFinishDate))
                        //     } else if (row.finishDate) {
                        //         finishDate = new Date(Date.parse(row.finishDate));
                        //     } else {
                        //         return "";
                        //     }
                        //     finishDate.setDate(finishDate.getDate()-1);
                        //     if (planFinishTime < finishDate) {
                        //         return "bg-danger text-dark"
                        //     } else {
                        //         return "";
                        //     }
                        // }
                    }
                    return ""
                }
            }
        },
        {
            key: 'actualStartDate',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.actualStartDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'actualFinishDate',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.actualFinishDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'finishDate',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.finishDate',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentUploadDate',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.attachmentUploadDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentList',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.attachmentList',
            sortable: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.maintenance.emMaMaintenanceWo.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
    ])
}

const filter = {
    emArchBasicDataCodeFilter: '',
    emMaMaintenanceCatIdFilter: '',
    statusFilter: '',
    workOrderCodeFilter: '',
    emMaMaintenanceScheduleIdFilter: '',
    repairPlanIdFilter: '',
    mmwoAuthorFilter: '',
    mmwoExecutorFilter: '',
    mmwoAcceptorFilter: '',
    emArchToolKitIdFilter: '',
    jobContentFilter: '',
    planStartDateGeFilter: '',
    planStartDateLeFilter: '',
    planEndDateGeFilter: '',
    planEndDateLeFilter: '',
    actualStartDateGeFilter: '',
    actualStartDateLeFilter: '',
    actualFinishDateGeFilter: '',
    actualFinishDateLeFilter: '',
    attachmentUploadDateGeFilter: '',
    attachmentUploadDateLeFilter: '',
    workflowQueryTypeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'emArchBasicDataCodeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.emArchBasicDataCode',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emArchBasicData'
            , correspondingField: 'code'
        }
    },
    {
        key: 'emMaMaintenanceCatIdFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.emMaMaintenanceCatId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emMaMaintenanceCat'
            , correspondingField: 'id'
        }
    },
    {
        key: 'statusFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.status',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emActProcessStatus'
            , showLabelSelectOne: true
            , selectFilter: {processBusinessEntityFilter: 'EmMaMaintenanceWo', statusFilter: 1}
        }
    },
    {
        key: 'workOrderCodeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.workOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'emMaMaintenanceScheduleIdFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.emMaMaintenanceScheduleId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emMaMaintenanceSchedule'
            , correspondingField: 'id'
        }
    },
    {
        key: 'mmwoAuthorFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.mmwoAuthor',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'mmwoExecutorFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.mmwoExecutor',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'mmwoAcceptorFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.mmwoAcceptor',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'jobContentFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.jobContent',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'planStartDateGeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.planStartDateGe',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'planStartDateLeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.planStartDateLe',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'planEndDateGeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.planEndDateGe',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'planEndDateLeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.planEndDateLe',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualStartDateGeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.actualStartDateGe',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualStartDateLeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.actualStartDateLe',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualFinishDateGeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.actualFinishDateGe',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'actualFinishDateLeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.actualFinishDateLe',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentUploadDateGeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.attachmentUploadDateGe',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentUploadDateLeFilter',
        label: 'label.em.maintenance.emMaMaintenanceWo.filter.attachmentUploadDateLe',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'ids',
        label: 'label.em.maintenance.emMaMaintenanceWo.entity.ids',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'emArchBasicDataCode',
        label: 'label.em.maintenance.emMaMaintenanceWo.entity.emArchBasicDataCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , required: true
            , entity: 'emArchBasicData'
            , correspondingField: 'code'
        }
    },
    {
        key: 'emMaMaintenanceCatId',
        label: 'label.em.maintenance.emMaMaintenanceWo.entity.emMaMaintenanceCatId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , required: true
            , entity: 'emMaMaintenanceCat'
            , correspondingField: 'id'
        }
    },
    {
        key: 'mmwoExecutor',
        label: 'label.em.maintenance.emMaMaintenanceWo.entity.mmwoExecutor',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , required: true
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'mmwoAcceptor',
        label: 'label.em.maintenance.emMaMaintenanceWo.entity.mmwoAcceptor',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , required: true
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'planStartDate',
        label: 'label.em.maintenance.emMaMaintenanceWo.entity.planStartDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'planEndDate',
        label: 'label.em.maintenance.emMaMaintenanceWo.entity.planEndDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'jobContent',
        label: 'label.em.maintenance.emMaMaintenanceWo.entity.jobContent',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'safeContent',
        label: 'label.em.maintenance.emMaMaintenanceWo.entity.safeContent',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachment',
        label: 'label.em.maintenance.emMaMaintenanceWo.entity.attachment',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    EmMaMaintenanceWo, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
